import { InlineStack } from '@shopify/polaris'

import { AdvancedDashboardFilter } from './advanced-filters'
import { ProductSelector } from './ProductSelector'
import { ProductVariantSelector } from './ProductVariantSelector'
import { SellingPlanSelector } from './SellingPlanSelector'

export const AdvancedDasbordFilterSelectors = ({
  filter,
  disabled,
}: {
  filter: AdvancedDashboardFilter
  disabled?: boolean
}) => {
  return (
    <InlineStack blockAlign="center" gap="200" align="start">
      <ProductSelector onSelect={filter.onProductSelect} disabled={disabled} />
      <ProductVariantSelector onSelect={filter.onProductVariantSelect} disabled={disabled} />
      <SellingPlanSelector
        sellingPlans={filter.sellingPlans}
        onChange={filter.setSellingPlans}
        disabled={disabled}
      />
    </InlineStack>
  )
}
